import React, { useState } from 'react';
import Chat from '../Chat/Chat.js';
import styles from './ChatHistory.module.css';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function ChatHistory({ chats }) {
  const [activeChatId, setActiveChatId] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleClick = (chat_id) => {
    navigate(`/c/${chat_id}`);
  };

  if (id) {
    if (activeChatId !== id) {
      setActiveChatId(id);
    }
  }

  return (
    <div className={styles.layout}>
      {
        chats.map((chat, index) => (
          <Chat 
            key={index} 
            chat={chat}
            onClick={handleClick}
            isActive={chat.chat_id === activeChatId} 
          />
        ))
      }
    </div>
  );
}

export default ChatHistory;
